// extracted by mini-css-extract-plugin
var _1 = "assets-js-GalleryPB-components-NoFavorites-NoFavorites-module__galleryLink__tdZGV";
var _2 = "assets-js-GalleryPB-components-NoFavorites-NoFavorites-module__wooHoomanWrapper__NwvQg";
export { _1 as "galleryLink", _2 as "wooHoomanWrapper" }
